// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import SimpleSlotView from 'assembly/views/SimpleSlotView';

class GoldenGateSlotView extends SimpleSlotView {}

export default GoldenGateSlotView;
